import { render, staticRenderFns } from "./tabsTutorial.vue?vue&type=template&id=73e040f4&scoped=true"
import script from "./tabsTutorial.vue?vue&type=script&lang=js"
export * from "./tabsTutorial.vue?vue&type=script&lang=js"
import style0 from "./tabsTutorial.vue?vue&type=style&index=0&id=73e040f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e040f4",
  null
  
)

export default component.exports